import React from 'react'
import { yupResolver } from '@hookform/resolvers/yup'

import { useControlledForm, useFormReset } from 'hooks'
import {
  mapInternalStateToPayload,
  mapPositionToInternalState,
} from './actions'
import { getDefaultValues } from './model'
import { getSchema } from './schema'

export const useMoveResourceModalForm = (state, handlers) => {
  const { position, hasInterviewModule } = state
  const { onConfirm } = handlers

  const [shouldReset, setShouldReset] = React.useState(false)

  const defaultValues = getDefaultValues()
  const schema = getSchema()

  const internalState = mapPositionToInternalState({
    ...position,
    hasInterviewModule,
  })

  const handleFormData = React.useCallback(
    data => {
      const payload = mapInternalStateToPayload(data)

      onConfirm({ ...payload }, { onSuccess: () => setShouldReset(true) })
    },
    [onConfirm],
  )

  const {
    control,
    formState,
    handleFormReset,
    handleFormSubmit,
    isDirtyOrInvalid,
  } = useControlledForm({
    values: position ? internalState : defaultValues,
    resolver: yupResolver(schema),
    handleFormData,
  })

  useFormReset({ shouldReset }, handleFormReset)

  return {
    state: { control, formState, isDirtyOrInvalid },
    handlers: { handleFormReset, handleFormSubmit },
  }
}
